import { useQuery } from '@tanstack/react-query';

import { getActiveDeliverySettings } from 'apis/delivery-settings-api/api';
import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { useFeatureFlags } from 'common/hooks';

export const useSelfDeliveryAreasLaunchTooltip = (venue: Venue) => {
  const { data: activeDeliverySettings, isFetching: isLoadingData } = useQuery(
    [`delivery-settings/${venue.id}`],
    () => getActiveDeliverySettings(venue.id),
    {
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  const { data: featureFlagData, isLoading: isLoadingFeatureFlag } = useFeatureFlags(
    ['merchant-admin-show-self-delivery-areas', 'merchant-admin-show-self-delivery-areas-launch-tooltip'],
    {
      venue_id: venue.id,
      venue_country: venue.country,
    },
  );

  const showDeliveryAreas =
    featureFlagData?.['merchant-admin-show-self-delivery-areas'] === 'on' &&
    (activeDeliverySettings?.activeDeliverySettingsType === 'self_delivery' ||
      activeDeliverySettings?.isFlexibleFulfillmentEnabled);

  // Use a separate feature flag for the tooltip to be able to control showing based on when translations exist
  const showLaunchTooltip =
    showDeliveryAreas && featureFlagData?.['merchant-admin-show-self-delivery-areas-launch-tooltip'] === 'on';

  return {
    isDisabled: !showLaunchTooltip,
    isLoading: isLoadingData || isLoadingFeatureFlag,
  };
};
